import {Radio} from 'antd';
import {MouseEvent} from 'react';

import * as styles from './review-filter-drawer.scss';

type OptionType = {
    label: JSX.Element;
    value: string;
};

type PropsType = {
    value: string;
    options: Array<OptionType>;
    onChange: (value: string) => void;
};

// Single-choice radio that clears the selection when the active option is clicked again.
// Empty string means "not selected" (matches the API contract used across review filters).
export function ReviewFilterToggleRadio(props: PropsType): JSX.Element {
    const {value, options, onChange} = props;

    function handleClick(optionValue: string): (event: MouseEvent<HTMLElement>) => void {
        return (event) => {
            (event.target as HTMLInputElement).blur();
            onChange(optionValue === value ? '' : optionValue);
        };
    }

    return (
        <Radio.Group className={styles.ReviewFilterDrawer_radioGroup} optionType="button" size="small" value={value}>
            {options.map((option) => (
                <Radio key={option.value} onClick={handleClick(option.value)} value={option.value}>
                    {option.label}
                </Radio>
            ))}
        </Radio.Group>
    );
}
